import { render, staticRenderFns } from "./SelectAvatar.vue?vue&type=template&id=27c6969a&"
import script from "./SelectAvatar.vue?vue&type=script&lang=js&"
export * from "./SelectAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SelectAvatar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports